<template>
    <div class="admin-footer">
       {{ tag }} © {{currentYear}} Velocity Vehicle Group. All Rights Reserved.
    </div>
</template>

<script>
    import Vue from 'vue';
    import {HTTP} from '../http-common';
    import {commonMixins} from '../mixins/commonMixins';
    import EventBus from './event-bus';

    var self;
    export default {
        name: 'FrontFooter',
        mixins: [commonMixins],
        data() {
            return {
                currentYear : '2019',
                tag:'',
            }
        },

        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self = this;
            self.getFooterTime();
            var userObj = JSON.parse(localStorage.getItem("user_obj"));
            if (userObj != null) {
                var userId = userObj.id;
                self.locationID = userObj.location_id;
                self.loadUserDetails(userId);
            }

            
            $("#menu li").removeClass("active");
            self.$store.dispatch('getRole');
            self.$store.dispatch('getUserTimeZone');
        },
        methods: {
            getFooterTime: function () {

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };

                HTTP.get('getfooteryear', config)
                    .then(function (response) {

                        if (response.data.code == '200') {
                            self.currentYear = response.data.content;
                            self.tag = response.data.tag;
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {

                        }
                    })
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/FrontFooter.vue